export default "__VITE_ASSET__CsZAUrvw__"